import type { SettingsRepository, SettingsWriteOptions } from '../../repositories/settings/settings.repository'
import type { SettingsPayload, SettingsRecord } from '../../models/settings.model'

export default class SettingsController {
  constructor(private settingsRepository: SettingsRepository) {
  }

  async getAll(): Promise<SettingsRecord[]> {
    return await this.settingsRepository.getAll()
  }

  async getScope<T extends SettingsPayload = SettingsPayload>(
    scope: string
  ): Promise<SettingsRecord<T> | null> {
    return await this.settingsRepository.getScope<T>(scope)
  }

  async putScope<T extends SettingsPayload = SettingsPayload>(
    scope: string,
    payload: T,
    options?: SettingsWriteOptions
  ): Promise<SettingsRecord<T>> {
    return await this.settingsRepository.putScope<T>(scope, payload, options)
  }

  async patchScope<T extends SettingsPayload = SettingsPayload>(
    scope: string,
    payload: Partial<T>
  ): Promise<SettingsRecord<T>> {
    return await this.settingsRepository.patchScope<T>(scope, payload)
  }

  async deleteScope(scope: string): Promise<void> {
    await this.settingsRepository.deleteScope(scope)
  }
}
